<template>
    <div>
      <div class="message" v-for="(message,index) in messages" v-bind:key="index" :class="{own: message.from === username}">
        <div style="margin-top: 5px"></div>
        <div class="text-center" v-if="index===0">{{formatDate(message.waktu)}}</div>
        <div class="text-center" v-if="index>0 && formatDate(messages[index-1].waktu)!==formatDate(message.waktu)">{{formatDate(message.waktu)}}</div>
        <div class="content">
          <div v-html="message.msg"></div>
          <ChatImage v-if="message.image" :imgsrc="message.image" @imageLoad="imageLoad"></ChatImage>
          <div class="msgwaktu text-right">{{formatwaktu(message.createat)}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import ChatImage from '@/components/chat/ChatImage'
import moment from 'moment'
export default {
  components: { ChatImage },
  data: () => ({
    user: localStorage.getItem('user')
  }),
  props: ['messages'],
  computed: {
    username () {
      return JSON.parse(this.user).id
    },
    tanggalpesan (val) {
      return this.formatDate(val)
    }
  },
  methods: {
    imageLoad () {
      // this.$emit('imageLoad')
    },
    formatwaktu (value) {
      return moment(value).add(0, 'hours').format('HH:mm:ss')
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD')
    }
  }
}
</script>

<style scoped>
.msgwaktu {
  font-size: 10px;
}
span.emoji {
  font-size: 20px;
  vertical-align: middle;
  line-height: 2;
}
.chat-container{
  box-sizing: border-box;
  height: calc(86vh - 9.5rem);
  overflow-y: auto;
  padding: 1px;
  background-color: #f2f2f2;
}
.scrollable {
  overflow-y: auto;
  height: 90vh;
}
.typer{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 4.9rem;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0,0,0,.2);
}
.typer input[type=text]{
  position: absolute;
  left: 2.5rem;
  padding: 1rem;
  width: 80%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 1.25rem;
}
.chat-container{
  box-sizing: border-box;
  height: calc(100vh - 9.5rem);
  overflow-y: auto;
  padding: 10px;
  background-color: #f2f2f2;
}
.message{
  margin-bottom: 3px;
}
.message.own{
  text-align: right;
}
.message.own .content{
  background-color: lightskyblue;
}
.chat-container .username{
  font-size: 18px;
  font-weight: bold;
}
.chat-container .content{
  padding: 8px;
  background-color: lightgreen;
  border-radius: 10px;
  display:inline-block;
  box-shadow: 0 0px 1px 0 rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12);
  max-width: 50%;
  word-wrap: break-word;
}
@media (max-width: 480px) {
  .chat-container .content{
    max-width: 60%;
  }
}
</style>
